import { SearchPage } from '@/search-page';
import { Router } from '../interfaces/router.interface';

const routerAdapter: Router = {
	currentRoute: SearchPage.instance.routing.currentRoute,
	push: SearchPage.instance.routing.navigateTo.bind(SearchPage.instance.routing),
	resolver: SearchPage.instance.routing.resolve.bind(SearchPage.instance.routing),
};

export default routerAdapter;

export { routerAdapter as router };
